import { render, staticRenderFns } from "./PassengersTravellingByRoute.vue?vue&type=template&id=568c0203"
import script from "./PassengersTravellingByRoute.vue?vue&type=script&lang=js"
export * from "./PassengersTravellingByRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports